import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ComponentRoleModel } from 'src/app/model/component-role.model';
import { CatComponent } from 'src/app/model/cat-component.model';
import { RolModel } from 'src/app/model/rol.model';
import { ComponentRoleService } from 'src/app/services/component-role.service';
import { CatComponentService } from 'src/app/services/cat-component.service';
import { RolService } from 'src/app/services/rol.service';
import { ModalComponentRoleComponent } from 'src/app/shared/modal-component-role/modal-component-role.component';

@Component({
  selector: 'app-component-roles',
  templateUrl: './component-roles.component.html',
  styleUrls: ['./component-roles.component.css']
})
export class ComponentRolesComponent implements OnInit {
  // estado pagina
  public viewStatus = 0;  // -1:error, 0:spinner, 1:tabla
  public componentRoles: ComponentRoleModel[] = [];
  public allComponentRoles: ComponentRoleModel[] = [];
  public components: CatComponent[] = [];
  public roles: RolModel[] = [];

  // filtros
  public selectedComponentId: string = null;
  public selectedRoleId: string = null;

  // opciones datatables
  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 100, targets: -1 }
    ],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth: false,
    paging: true,
    pageLength: 50,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private modalService: NgbModal,
    private componentRoleService: ComponentRoleService,
    private catComponentService: CatComponentService,
    private rolService: RolService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.loadData();
  }

  //
  add = () => {
    let componentRole = new ComponentRoleModel();
    componentRole.activeId = 1;
    let modalRef = this.modalService.open(ModalComponentRoleComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'dark-modal',
      size: 'md'
    });
    modalRef.componentInstance.componentRole = { ...componentRole };
    modalRef.componentInstance.components = this.components;
    modalRef.componentInstance.roles = this.roles;
    modalRef.componentInstance.mode = 'create';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.loadData();
      }
    );
  }

  toggleActive = (item: ComponentRoleModel) => {
    item.activeId = item.activeId === 1 ? 0 : 1;
    this.componentRoleService.save(item)
      .pipe(
        tap((resp: any) => {
          if (resp && resp.codeHttpStatus === 200) {
            this.toastr.success('Estado actualizado exitosamente.');
          } else {
            // Revertir cambio si falla
            item.activeId = item.activeId === 1 ? 0 : 1;
            this.toastr.error('Error al actualizar el estado.');
          }
        }),
        catchError(error => {
          // Revertir cambio si falla
          item.activeId = item.activeId === 1 ? 0 : 1;
          return of(this.toastr.error('Error al actualizar el estado.'));
        })
      )
      .subscribe();
  }

  delete = (item: ComponentRoleModel) => {
    Swal.fire({
      icon: 'warning',
      title: '¿Eliminar asignación?',
      html: `Se eliminará el rol <b>${this.getRoleName(item.roleId)}</b> del menú <b>${this.getComponentName(item.componentId)}</b>.`,
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      background: 'rgba(15,23,42,0.97)',
      color: '#f8fafc',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: 'rgba(148,163,184,0.25)',
      buttonsStyling: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.componentRoleService.delete(item.componentId, item.roleId)
          .pipe(
            tap((resp: any) => {
              if (resp && resp.codeHttpStatus === 200) {
                this.toastr.success('Asignación eliminada exitosamente.');
                this.loadData();
              } else {
                this.toastr.error('Error al eliminar la asignación.');
              }
            }),
            catchError(error => {
              return of(this.toastr.error('Error al eliminar la asignación.'));
            })
          )
          .subscribe();
      }
    });
  }

  // FILTROS
  applyFilters = () => {
    console.log('Aplicando filtros - ComponentId:', this.selectedComponentId, 'RoleId:', this.selectedRoleId);

    this.componentRoles = this.allComponentRoles.filter(cr => {
      let matchComponent = true;
      let matchRole = true;

      if (this.selectedComponentId) {
        // Comparar tanto en formato string como número
        const selectedId = this.selectedComponentId.toString();
        const crId = cr.componentId ? cr.componentId.toString() : '';
        matchComponent = crId === selectedId;
      }
      if (this.selectedRoleId) {
        matchRole = cr.roleId === this.selectedRoleId;
      }

      return matchComponent && matchRole;
    });

    console.log('Resultados filtrados:', this.componentRoles.length, 'de', this.allComponentRoles.length);
  }

  clearFilters = () => {
    this.selectedComponentId = null;
    this.selectedRoleId = null;
    this.componentRoles = [...this.allComponentRoles];
  }

  // INFO
  loadData = () => {
    forkJoin([
      this.componentRoleService.getAll(),
      this.catComponentService.getComponents(),
      this.rolService.getAll()
    ])
    .pipe(
      tap((resp: any[]) => {
        this.allComponentRoles = resp[0].data || [];
        this.componentRoles = [...this.allComponentRoles];

        // Aplanar componentes jerárquicos
        const componentsData = resp[1].data || [];
        this.components = this.flattenComponents(componentsData);

        this.roles = resp[2].data || [];

        console.log('ComponentRoles loaded:', this.componentRoles);
        console.log('Components loaded:', this.components);
        console.log('Roles loaded:', this.roles);

        this.viewStatus = 1;
      }),
      catchError(error => {
        this.viewStatus = -1;
        return of(this.toastr.error('Ocurrió un error al cargar los datos.'));
      })
    )
    .subscribe();
  }

  flattenComponents = (components: CatComponent[]): CatComponent[] => {
    let result: CatComponent[] = [];
    components.forEach(comp => {
      result.push(comp);
      if (comp.componentChild && comp.componentChild.length > 0) {
        result = result.concat(this.flattenComponents(comp.componentChild as any));
      }
    });
    return result;
  }

  // HELPERS
  getComponentName = (componentId: number): string => {
    if (!componentId) return '-';

    // Convertir a string para comparar con CatComponent.componentId (que es string)
    const comp = this.components.find(c =>
      c.componentId === componentId.toString()
    );

    if (!comp) {
      console.warn(`Componente no encontrado: ${componentId}`, this.components.map(c => c.componentId));
    }

    return comp ? comp.componentName : `ID: ${componentId}`;
  }

  getRoleName = (roleId: string): string => {
    const rol = this.roles.find(r => r.vNombre === roleId);
    return rol ? rol.vNombre : roleId;
  }
}
